(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var overlay  = document.getElementById('cart-overlay');
    var drawer   = document.getElementById('cart-drawer');
    var body     = document.getElementById('cart-drawer-body');
    var footer   = document.getElementById('cart-drawer-footer');
    var countEl  = document.getElementById('cart-drawer-item-count');
    var subtotal = document.getElementById('cart-drawer-subtotal');
    var closeBtn = document.getElementById('cart-drawer-close');
    var cartIcon = document.querySelector('.site-header__cart');

    if (!drawer) return;

    function fmt(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    function updateHeaderCount(count) {
      var badge = document.querySelector('.cart-count');
      if (!badge) return;
      badge.textContent = count;
      badge.classList.toggle('cart-count--hidden', count === 0);
    }

    function open() {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('sd-cart-open');
      fetchAndRender();
    }

    function close() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.classList.remove('sd-cart-open');
    }

    function showLoading() {
      body.innerHTML = '<div class="cart-drawer__loading"><div class="cart-drawer__spinner"></div></div>';
      footer.hidden = true;
    }

    function renderCart(cart) {
      updateHeaderCount(cart.item_count);
      if (countEl) countEl.textContent = cart.item_count;

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<div class="cart-drawer__empty">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
          + '<p>Your cart is empty</p>'
          + '<a href="/collections/all">Start shopping &rarr;</a>'
          + '</div>';
        footer.hidden = true;
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        var imgHtml = item.image
          ? '<img class="cart-item__img" src="' + item.image + '" alt="' + item.title + '" width="72" height="72" loading="lazy">'
          : '';
        var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
          : '';
        html += '<div class="cart-item" data-key="' + item.key + '">'
          + '<div class="cart-item__img-wrap">' + imgHtml + '</div>'
          + '<div class="cart-item__info">'
          + '<p class="cart-item__title">' + item.product_title + '</p>'
          + variantHtml
          + '<div class="cart-item__bottom">'
          + '<div class="cart-item__qty">'
          + '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">&minus;</button>'
          + '<span class="cart-item__qty-num">' + item.quantity + '</span>'
          + '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">&plus;</button>'
          + '</div>'
          + '<span class="cart-item__price">' + fmt(item.final_line_price) + '</span>'
          + '</div>'
          + '</div>'
          + '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove item">&times;</button>'
          + '</div>';
      });
      body.innerHTML = html;

      if (subtotal) subtotal.textContent = fmt(cart.total_price);
      footer.hidden = false;

      body.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.dataset.key;
          var delta = parseInt(btn.dataset.delta, 10);
          var row = body.querySelector('.cart-item[data-key="' + key + '"]');
          var num = row ? parseInt(row.querySelector('.cart-item__qty-num').textContent, 10) : 1;
          changeItem(key, Math.max(0, num + delta));
        });
      });

      body.querySelectorAll('.cart-item__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          changeItem(btn.dataset.key, 0);
        });
      });
    }

    function fetchAndRender() {
      showLoading();
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() {
          body.innerHTML = '<div class="cart-drawer__empty"><p>Could not load cart.</p></div>';
        });
    }

    function changeItem(key, qty) {
      var row = body.querySelector('.cart-item[data-key="' + key + '"]');
      if (row) row.classList.add('cart-item--updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() { fetchAndRender(); });
    }

    function showFeedback(title) {
      var el = document.createElement('div');
      el.className = 'cart-add-feedback';
      el.textContent = '✓ ' + title + ' added to cart';
      document.body.appendChild(el);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { el.classList.add('show'); });
      });
      setTimeout(function() {
        el.classList.remove('show');
        setTimeout(function() { el.remove(); }, 350);
      }, 2200);
    }

    // Cart icon opens drawer
    if (cartIcon) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        open();
      });
    }

    // Close triggers
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Intercept add-to-cart forms site-wide
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart add failed with status ' + r.status);
          return r.json();
        })
        .then(function(item) {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          if (item.title) showFeedback(item.title);
          open();
        })
        .catch(function(err) {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          console.error('Add to cart failed', err);
          HTMLFormElement.prototype.submit.call(form);
        });
    });

    // Expose globally so other scripts can open the drawer
    window.cartDrawer = { open: open, close: close, refresh: fetchAndRender };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (function() {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;

    var root = document.documentElement;

    if (localStorage.getItem('sd_cookie_consent')) {
      banner.style.display = 'none';
      return;
    }

    function publishHeight() {
      root.style.setProperty('--sd-cookie-h', banner.offsetHeight + 'px');
    }

    document.body.classList.add('sd-cookie-open');
    publishHeight();
    window.addEventListener('resize', publishHeight);

    /*
      Register the choice with Shopify's Customer Privacy API so tracking
      pixels/analytics are genuinely switched on or off, not just visually
      dismissed. Loaded lazily; if it fails we still store the choice locally.
    */
    function registerConsent(granted) {
      function apply() {
        if (!window.Shopify || !window.Shopify.customerPrivacy) return;
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted
          },
          function() {}
        );
      }
      if (window.Shopify && window.Shopify.customerPrivacy) {
        apply();
      } else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function(error) {
            if (!error) apply();
          }
        );
      }
    }

    function dismiss(choice) {
      localStorage.setItem('sd_cookie_consent', choice);
      registerConsent(choice === 'accepted');
      banner.classList.add('is-hidden');
      document.body.classList.remove('sd-cookie-open');
      root.style.setProperty('--sd-cookie-h', '0px');
      window.removeEventListener('resize', publishHeight);
      setTimeout(function() { banner.style.display = 'none'; }, 320);
    }

    document.getElementById('cookie-accept').addEventListener('click', function() {
      dismiss('accepted');
    });

    document.getElementById('cookie-decline').addEventListener('click', function() {
      dismiss('declined');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var input = document.getElementById('header-search-input');
    var dropdown = document.getElementById('search-suggestions');
    if (!input || !dropdown) return;

    var debounceTimer = null;
    var activeIndex = -1;
    var lastQuery = '';

    function fmt(price) {
      return '£' + parseFloat(price).toFixed(2);
    }

    function placeholderSvg() {
      return '<div class="search-suggestion__placeholder"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg></div>';
    }

    function render(products, query) {
      if (!products || !products.length) {
        dropdown.innerHTML = '<div class="search-suggestions__empty">No results for &ldquo;' + query + '&rdquo;</div>';
        dropdown.hidden = false;
        return;
      }
      var html = '<span class="search-suggestions__label">Products</span>';
      products.forEach(function(p, i) {
        var imgHtml = p.featured_image && p.featured_image.url
          ? '<img class="search-suggestion__img" src="' + p.featured_image.url + '" alt="" width="42" height="42" loading="lazy">'
          : placeholderSvg();
        html += '<a href="' + p.url + '" class="search-suggestion" role="option" data-idx="' + i + '">'
          + imgHtml
          + '<div class="search-suggestion__info">'
          + '<div class="search-suggestion__title">' + p.title + '</div>'
          + '<div class="search-suggestion__price">' + fmt(p.price) + '</div>'
          + '</div></a>';
      });
      html += '<div class="search-suggestions__footer">'
        + '<a href="/search?q=' + encodeURIComponent(query) + '" class="search-suggestions__all">See all results for &ldquo;' + query + '&rdquo; &rarr;</a>'
        + '</div>';
      dropdown.innerHTML = html;
      dropdown.hidden = false;
      activeIndex = -1;
    }

    function close() {
      dropdown.hidden = true;
      activeIndex = -1;
    }

    function fetchSuggestions(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6'
        + '&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== lastQuery) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function() { close(); });
    }

    input.addEventListener('input', function() {
      var q = input.value.trim();
      lastQuery = q;
      clearTimeout(debounceTimer);
      if (q.length < 2) { close(); return; }
      dropdown.innerHTML = '<div class="search-suggestions__spinner">Searching&hellip;</div>';
      dropdown.hidden = false;
      debounceTimer = setTimeout(function() { fetchSuggestions(q); }, 220);
    });

    input.addEventListener('keydown', function(e) {
      var items = dropdown.querySelectorAll('.search-suggestion');
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        items[activeIndex].click();
        return;
      }
      items.forEach(function(el, i) { el.classList.toggle('is-active', i === activeIndex); });
    });

    input.addEventListener('focus', function() {
      if (lastQuery.length >= 2) dropdown.hidden = false;
    });

    document.addEventListener('click', function(e) {
      if (!dropdown.hidden && !dropdown.contains(e.target) && e.target !== input) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
